/*
 * ALARMS
 */
export const ADD_ALARM = "addAlarm";
export const FETCH_ALARMS = "fetchAlarms";
export const DELETE_ALARM = "deleteAlarm";

/*
 * STOCKS AND EXCHANGES
 */
export const FETCH_EXCHANGES = "fetchExchanges";
export const FETCH_STOCKS = "fetchStocks";
export const RESET_STOCKS = "resetStocks";

/*
 * USER LOGIN AND AUTH
 */
export const CHECK_AUTH = "checkAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
